export const TRANSLATIONS = {
    EN: {
        ORGANIZATION: {
            DASHBOARD_BANNER_TITLE: 'Manage all your <br> organisations on the go',
            DASHBOARD_BANNER_DESCRIPTION: 'The new {tenant} app is the easiest way to manage all of your organisations. From anywhere you like.',
            SHORTCUTS: 'Shortcuts',
            VIEW_COMPANY_PASSPORT: 'View company passport',
            VIEW_PERSONS: 'View persons',
            DOCUMENTS: 'View documents',
            INCORPORATION_DATE: 'Incorporation Date',
            SHARES_TRANSACTIONS: 'Share transactions',
            SHARES_CAPITAL: 'Share capital',
            SHAREHOLDERS: 'Shareholders',
            SHAREHOLDERS_DETAILS: 'Shareholders details',
            SHARES_AMOUNT: 'Amount',
            FULLY_PAID: 'Fully paid',
            ENCOURAGED: 'Encumbered',
            SOCIAL_CAPITAL: 'Social capital',
            POSTED_CAPITAL: 'Issued capital',
            AVERAGE_NOMINAL_SHARE_VALUE: 'Avg. Nominal share value',
            NOMINAL_SHARE_VALUE: 'Nominal share value',
            ORGANIZATION_DETAILS: 'Organization details',
            APPLICATION_DETAILS: 'Application details',
            INFORMATION_INCORPORATION: 'Information incorporation {name}',
            ACTIVITY_SUMMARY: 'Activity summary',
            ACTIVITY_SUMMARY_HINT: "Summarised by AI from the client's answers",
            COMPANY_NAME: 'Organization name',
            CHAMBER_OF_COMMERCE_NUMBER: 'Chamber of Commerce number',
            REGISTERED_OFFICE: 'Registered office',
            DATE_OF_ESTABLISHMENT: 'Date of establishment',
            NAME_OF_EXECUTIVE_NOTARY: 'Name of executive notary',
            EVENTS: 'Events',
            CAPITAL: 'Capital',
            ISSUES_CAPITAL: 'Issued capital',
            PAID_UP_CAPITAL: 'Paid-up capital',
            SHARES_PARTIALLY_PAID_UP_CAPITAL: 'Shares partially paid up',
            CURRENCY_SHARES: 'Currency Shares',
            TYPE_OF_SHARES: 'Type of Shares',
            TOTAL_NUMBER_OF_SHARES: 'Total Number of Shares',
            NOMINAL_AMOUNT_PER_SHARE: 'Nominal Amount Per Share',
            PLACEMENT_DATE: 'Placement date',
            SHARE_EVENTS: 'Share transactions',
            ORGANIZATION_EVENTS: 'Organization events',
            EVENT_TYPE: 'Event type',
            SHARE_TYPE: 'Share type',
            REQUEST_CHANGE: 'Request change',
            UPDATE_SHAREHOLDERS: 'Update shareholders',
            CHANGE_COMPANY_TYPE: 'Update company',
            CHANGE_ARTICLES_OF_ASSOCIATION: 'Change articles of association',
            LIQUIDATE_COMPANY: 'Liquidate company',
            INCORPORATION_FOUNDATION: 'Incorporate Foundation',
            NO_CONTRACTS: 'You have no contracts yet, create your first contract:',
            DIGITAL_SHAREHOLDER_REGISTER: 'Digital shareholder register',
            OTHER_ACTIVITIES: 'Other activities',
            COMPANY_PHONE_NUMBER: 'Company phone number',
            UBOS_DETAILS: 'UBO details',
            UBO: "How many (pseudo) UBO's does this holding have?",
            ALL_OPTIONS: 'All options',
            RECIPIENT: 'Recipient',
            ADJUSTMENTS_VERIFY: 'Please verify if all your adjustments is correct',
            CHANGE_COMPANY: 'Change company',
            UBO_REGISTRATION: 'UBO registration',
        },
        EVENTS_DETAILS: {
            ORGANIZATION_DEED_CHANGED: 'Deed changed',
            ORGANIZATION_EXTRACT_CHANGED: 'Extract changed',
            ORGANIZATION_CREATED: 'Organization incorporated',
            ORGANIZATION_INCORPORATED: 'Organization incorporated',
            ORGANIZATION_NAME_CHANGED: 'Name change',
            BY_DEED_OF_CIVIL_LAW_NOTARY: 'By deed of civil law notary',
            DATE_OF_CHANGE: 'Date of change',
            NEW_NAME: 'New name',
            VIEW_DEED: 'View deed',
            ORGANIZATION_REGISTERED_CITY_CHANGED: 'Change registered office',
            SHARE_TRANSFER: 'Share transfer',
            ISSUANCES_OF_NEW_SHARES: 'Issuances of new shares',
            ACQUISITION_AT_INCORPORATION: 'Acquisition at incorporation',
            ACQUISITION_AT_CONTRIBUTION: 'Acquisition at contribution',
            OBJECTION_OF_THE_USUFRUCTUARY: 'Objection of the Usufructuary',
            OBJECTION_OF_THE_DEPOSITORY: 'Objection of the Depository',
            OBJECTION_OF_THE_PLEDGE: 'Objection of the Pledge',
            CANCELLATION_OF_SHARES: 'Intrekking van aandelen',
            SHAREHOLDER: 'Shareholder',
            FIRST_REGISTRATION: 'First registration',
            LEGAL_FACT: 'Legal fact',
            AMOUNT_OF_SHARES: 'Amount of shares',
            TYPE_OF_SHARE: 'Type of share',
            NOMINAL_AMOUNT_PER_SHARE: 'Nominal amount per share',
            NUMBERS_SHARES: 'Numbers of the shares',
            DATE_OF_LEGAL_FACT: 'Date of legal fact',
            DATE_OF_ACKNOWLEDGEMENT: 'Date of acknowledgement',
            DATE_OF_REGISTRATION: 'Date of registration',
            NEW_REGISTERED_OFFICE: 'New registered office',
            SEQUENCE: 'Sequence',
            SALE_AND_DELIVERY_SHARE: 'Sale and delivery of shares',
            INCORPORATION_SHARE_ISSUED: 'Acquisition at incorporation',
            REGARDING_THE_SHARES: 'Regarding the shares',
        },
        SHAREHOLDERS_DETAILS: {
            ORGANIZATION: 'Organization',
            USER: 'Natural person',
            SHAREHOLDER_TYPE: 'Shareholder type',
            OWNERSHIP_PERCENTAGE: 'Ownership percentage',
            TYPE_OF_SHARES: 'Type of shares',
            SHAREHOLDER_INFORMATION: '{shareholder} information',
            DIRECTOR: 'Director',
            OTHER_INFORMATION: 'Other information',
            AMOUNT: 'Amount',
            TYPE_OF_TRANSACTION: 'Type of transaction',
            FROM: 'From',
            TO: 'To',
            DATE: 'Date',
            NAME: 'Name',
            FIRST_REGISTRATION: 'First registration',
            CHANGE: 'Change',
        },
        BOOKKEEPING: {
            BANNER_TITLE: 'Boekhouding volledig uitbesteden?',
            CALL_TO_ACTION: 'Aan de slag',
            BOOKKEPPER: 'Jouw boekhouder',
            PACKET: 'Jouw pakket',
            LATEST_PAYMENTS: 'Latest payments',
            ACCOUNTING_LINKS: 'Accounting links',
            PROCESS_TITLE: 'Subscription authorization',
            COMPLETED: 'Completed',
            PAYMENT_LINK: 'Pay',
            PAYMENT_DESCRIPTION: 'You need to pay {price} to authorize your subscription',
        },
    },
    NL: {
        ORGANIZATION: {
            DASHBOARD_BANNER_TITLE: 'Beheer al uw organisaties onderweg',
            DASHBOARD_BANNER_DESCRIPTION: 'De nieuwe {tenant}-app is de makkelijkste manier om al uw organisaties te beheren. Van waar je maar wilt.',
            SHORTCUTS: 'Sneltoetsen',
            VIEW_COMPANY_PASSPORT: 'Bekijk bedrijfspaspoort',
            VIEW_PERSONS: 'Bekijk personen',
            DOCUMENTS: 'Documenten bekijken',
            INCORPORATION_DATE: 'Incorporation Date',
            SHARES_TRANSACTIONS: 'Aandelentransacties',
            SHARES_CAPITAL: 'Aandelenkapitaal',
            SHAREHOLDERS: 'Aandeelhouders',
            SHAREHOLDERS_DETAILS: 'Meer over aandeelhouders',
            SHARES_AMOUNT: 'Aantal',
            FULLY_PAID: 'Volgestort',
            ENCOURAGED: 'Bezwaard',
            SOCIAL_CAPITAL: 'Maatschappelijk kapitaal',
            POSTED_CAPITAL: 'Geplaats kapitaal',
            AVERAGE_NOMINAL_SHARE_VALUE: 'Gem. Nominale waarde aandeel',
            NOMINAL_SHARE_VALUE: 'Nominale waarde aandeel',
            ORGANIZATION_DETAILS: 'Details Vennootschap',
            APPLICATION_DETAILS: 'Gegevens van de aanvraag',
            INFORMATION_INCORPORATION: 'Informatie oprichting {name}',
            ACTIVITY_SUMMARY: 'Samenvatting activiteiten',
            ACTIVITY_SUMMARY_HINT: 'Door AI samengevat uit de antwoorden van de klant',
            COMPANY_NAME: 'Naam Vennootschap',
            CHAMBER_OF_COMMERCE_NUMBER: 'KVK nummer',
            REGISTERED_OFFICE: 'Statutaire vestigingsplaats',
            DATE_OF_ESTABLISHMENT: 'Datum van oprichting',
            NAME_OF_EXECUTIVE_NOTARY: 'Naam uitvoerende notaris',
            EVENTS: 'Gebeurtenissen',
            CAPITAL: 'Kapitaal',
            ISSUES_CAPITAL: 'Geplaatst kapitaal',
            PAID_UP_CAPITAL: 'Gestort kapitaal',
            SHARES_PARTIALLY_PAID_UP_CAPITAL: 'Deels volgestorte aandelen',
            CURRENCY_SHARES: 'Munteenheid Aandelen',
            TYPE_OF_SHARES: 'Type Aandelen',
            TOTAL_NUMBER_OF_SHARES: 'Totaal Aantal Aandelen',
            NOMINAL_AMOUNT_PER_SHARE: 'Nominaal Bedrag Per Aandeel',
            PLACEMENT_DATE: 'Plaatsingsdatum',
            SHARE_EVENTS: 'Aandelentransacties',
            ORGANIZATION_EVENTS: 'Statutenwijzigingen',
            EVENT_TYPE: 'Event type',
            SHARE_TYPE: 'Share type',
            REQUEST_CHANGE: 'Wijziging aanvragen',
            UPDATE_SHAREHOLDERS: 'Aandeelhouders wijzigen',
            CHANGE_COMPANY_TYPE: 'BV wijzigen',
            CHANGE_ARTICLES_OF_ASSOCIATION: 'Statuten wijzigen',
            LIQUIDATE_COMPANY: 'Bedrijf opheffen',
            INCORPORATION_FOUNDATION: 'Stichting oprichten',
            NO_CONTRACTS: 'U heeft nog geen contracten, maak uw eerste contract:',
            DIGITAL_SHAREHOLDER_REGISTER: 'Digitaal aandeelhoudersregister',
            OTHER_ACTIVITIES: 'Andere activiteiten',
            COMPANY_PHONE_NUMBER: 'Telefoonnummer onderneming',
            UBOS_DETAILS: 'Meer over UBO',
            UBO: "Hoeveel (pseudo) UBO's heeft deze holding?",
            ALL_OPTIONS: 'Alle opties',
            RECIPIENT: 'Ontvanger',
            ADJUSTMENTS_VERIFY: 'Ik heb geverifieerd dat deze gegevensaanpassingen correct zijn',
            CHANGE_COMPANY: 'Bedrijf aanpassen',
            UBO_REGISTRATION: 'UBO registratie',
        },
        EVENTS_DETAILS: {
            ORGANIZATION_DEED_CHANGED: 'Statutenwijziging',
            ORGANIZATION_EXTRACT_CHANGED: 'Wijziging KvK uittreksel',
            ORGANIZATION_CREATED: 'Opgericht',
            ORGANIZATION_INCORPORATED: 'Opgericht',
            ORGANIZATION_NAME_CHANGED: 'Naamswijziging',
            BY_DEED_OF_CIVIL_LAW_NOTARY: 'Naam uitvoerende notaris',
            DATE_OF_CHANGE: 'Datum wijziging',
            NEW_NAME: 'Nieuwe naam vennootschap',
            VIEW_DEED: 'Bekijk akte',
            ORGANIZATION_REGISTERED_CITY_CHANGED: 'Wijziging vestigingsplaats',
            SHARE_TRANSFER: 'Verkoop en levering',
            ISSUANCES_OF_NEW_SHARES: 'Uitgifte nieuwe aandelen',
            ACQUISITION_AT_INCORPORATION: 'Uitgifte bij oprichting',
            ACQUISITION_AT_CONTRIBUTION: 'Uitgifte bij inbreng',
            OBJECTION_OF_THE_USUFRUCTUARY: 'Bezwaring met vruchtgebruik',
            OBJECTION_OF_THE_DEPOSITORY: 'Bezwaring met certificering',
            OBJECTION_OF_THE_PLEDGE: 'Objection of the Pledge',
            CANCELLATION_OF_SHARES: 'Intrekking van aandelen',
            SHAREHOLDER: 'Aandeelhouder',
            FIRST_REGISTRATION: 'Eerste inschrijving',
            LEGAL_FACT: 'Rechtsfeit',
            AMOUNT_OF_SHARES: 'Aantal aandelen',
            TYPE_OF_SHARE: 'Soort aandelen',
            NOMINAL_AMOUNT_PER_SHARE: 'Nominale waarde per aandeel',
            NUMBERS_SHARES: 'Nummering aandelen',
            DATE_OF_LEGAL_FACT: 'Datum rechtsfeit',
            DATE_OF_ACKNOWLEDGEMENT: 'Datum erkenning ',
            DATE_OF_REGISTRATION: 'Datum inschrijving',
            NEW_REGISTERED_OFFICE: 'Nieuwe vestigingsplaats',
            SEQUENCE: 'Volgorde',
            SALE_AND_DELIVERY_SHARE: 'Verkoop en levering van aandelen',
            INCORPORATION_SHARE_ISSUED: 'Uitgifte bij oprichting',
            REGARDING_THE_SHARES: 'Betreft de aandelen',
        },
        SHAREHOLDERS_DETAILS: {
            ORGANIZATION: 'Organisatie',
            USER: 'Natuurlijk persoon',
            SHAREHOLDER_TYPE: 'Type aandeelhouder',
            OWNERSHIP_PERCENTAGE: 'Eigendomspercentage',
            TYPE_OF_SHARES: 'Type aandelen',
            SHAREHOLDER_INFORMATION: 'Gegevens {shareholder}',
            DIRECTOR: 'Bestuurder',
            OTHER_INFORMATION: 'Overige  gegevens',
            AMOUNT: 'Bedrag',
            TYPE_OF_TRANSACTION: 'Soort transactie',
            FROM: 'Van',
            TO: 'Naar',
            DATE: 'Datum',
            NAME: 'Naam',
            FIRST_REGISTRATION: 'Eerste registratie',
            CHANGE: 'Wijziging',
        },
        BOOKKEEPING: {
            BANNER_TITLE: 'Boekhouding volledig uitbesteden?',
            CALL_TO_ACTION: 'Aan de slag',
            BOOKKEPPER: 'Jouw boekhouder',
            PACKET: 'Jouw pakket',
            LATEST_PAYMENTS: 'Laatste betalingen',
            ACCOUNTING_LINKS: 'Boekhoudkoppelingen',
            PROCESS_TITLE: 'Machtiging abonnement',
            COMPLETED: 'Voltooid',
            PAYMENT_LINK: 'Betaal',
            PAYMENT_DESCRIPTION: 'U dient nu {price} te betalen zodat wij uw boekhouding kunnen starten.',
        },
    },
};
